import { ShieldAlert } from "lucide-react";
import PaginaFiscal from "../_components/pagina-fiscal";
import CardsPendencias from "./_components/cards-pendencias";
import TabelaPendencias from "./_components/tabela-pendencias";
import { usePendenciasPorCard } from "./hooks";
import { useAcoesFiscais, useConsultaFiscal, usePaginacao } from "../hooks";
import {
	baixarXml,
	cancelarNota,
	consultarNota,
	imprimirNota,
	listarPendencias,
	fonteDocumentos,
	transmitirNota,
} from "../api/documentos";

const CAMPOS_FILTRO = ["modelo", "venda", "cpfCnpj", "cliente"];

export default function MonitorFiscal() {
	const consulta = useConsultaFiscal(listarPendencias, "filtroMonitorFiscal");
	const { card, selecionar, contagem, visiveis } = usePendenciasPorCard(consulta.itens);
	const paginacao = usePaginacao(visiveis);
	const acoes = useAcoesFiscais(
		{ imprimir: imprimirNota, baixarXml, consultar: consultarNota, cancelar: cancelarNota, transmitir: transmitirNota },
		consulta.recarregar
	);

	return (
		<PaginaFiscal
			icone={ShieldAlert}
			titulo="Monitor Fiscal"
			subtitulo="Situações fiscais que precisam de atenção"
			consulta={consulta}
			camposFiltro={CAMPOS_FILTRO}
			acoes={acoes}
			fonte={fonteDocumentos}
		>
			<CardsPendencias contagem={contagem} selecionado={card} onSelecionar={selecionar} />

			<TabelaPendencias
				pendencias={paginacao.itensPagina}
				total={visiveis.length}
				pagina={paginacao.pagina}
				totalPaginas={paginacao.totalPaginas}
				onPagina={paginacao.setPagina}
				carregando={consulta.carregando}
				onAcao={acoes.executar}
				jaBuscou={!!consulta.filtrosAplicados}
			/>
		</PaginaFiscal>
	);
}
